import { ApiCore } from '@/services/api/utils/core.js';
import { apiProvider } from "@/services/api/utils/provider.js";
import axios from "axios";
import { handleResponse, handleError } from "@/services/api/utils/response.js";

const url = 'v1/source_config/system'
const plural = 'system'
const single = 'system'

const systemConfig = new ApiCore({

	/* Get all source system configuration */
	index: true,

	/* Create new source system configuration */
	create: true,

	/* Update source system configuration */
	updateById: true,

	/* Delete source system configuration */
	remove: true,

	/* Remaining props */
	findOne: false,
	findAll: false,
	url: url,
	plural: plural,
	single: single
});

systemConfig.getSourceSystemLists = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${params}`)
		.then(handleResponse)
		.catch(handleError);
};

systemConfig.getSourceSystemFilters = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/filters`)
		.then(handleResponse)
		.catch(handleError);
};

export default systemConfig
